const Config = {
  delivery_method_id: {
    get() {
      return this.$store.state.SettingsModule.Config.config.delivery_method_id || null;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setConfigProperty', { property: 'delivery_method_id', payload });
    },
  },
  delivery_option_id: {
    get() {
      return this.$store.state.SettingsModule.Config.merchant_delivery_options || [];
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setProperty', { property: 'merchant_delivery_options', payload });
    },
  },
  home_delivery_option_id: {
    get() {
      return this.$store.state.SettingsModule.Config.config.home_delivery_option_id;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setConfigProperty', { property: 'home_delivery_option_id', payload });
    },
  },
  payment_method_id: {
    get() {
      return this.$store.state.SettingsModule.Config.config.payment_method_id;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setConfigProperty', { property: 'payment_method_id', payload });
    },
  },
  fb_client_id: {
    get() {
      return this.$store.state.SettingsModule.Config.config.fb_client_id;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setConfigProperty', { property: 'fb_client_id', payload });
    },
  },
  fb_client_secret: {
    get() {
      return this.$store.state.SettingsModule.Config.config.fb_client_secret;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setConfigProperty', { property: 'fb_client_secret', payload });
    },
  },
  fb_redirect_uri: {
    get() {
      return this.$store.state.SettingsModule.Config.config.fb_redirect_uri;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setConfigProperty', { property: 'fb_redirect_uri', payload });
    },
  },
  flw_merchant_id: {
    get() {
      return this.$store.state.SettingsModule.Config.config.flw_merchant_id;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setConfigProperty', { property: 'flw_merchant_id', payload });
    },
  },
  vat_rate: {
    get() {
      return this.$store.state.SettingsModule.Config.config.vat_rate;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setConfigProperty', { property: 'vat_rate', payload });
    },
  },
  flw_secret_key: {
    get() {
      return this.$store.state.SettingsModule.Config.config.flw_secret_key;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setConfigProperty', { property: 'flw_secret_key', payload });
    },
  },
  gg_client_id: {
    get() {
      return this.$store.state.SettingsModule.Config.config.gg_client_id;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setConfigProperty', { property: 'gg_client_id', payload });
    },
  },
  gg_client_secret: {
    get() {
      return this.$store.state.SettingsModule.Config.config.gg_client_secret;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setConfigProperty', { property: 'gg_client_secret', payload });
    },
  },
  gg_redirect_uri: {
    get() {
      return this.$store.state.SettingsModule.Config.config.gg_redirect_uri;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setConfigProperty', { property: 'gg_redirect_uri', payload });
    },
  },
  paystack_merchant_id: {
    get() {
      return this.$store.state.SettingsModule.Config.config.paystack_merchant_id;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setConfigProperty', { property: 'paystack_merchant_id', payload });
    },
  },
  paystack_secret_key: {
    get() {
      return this.$store.state.SettingsModule.Config.config.paystack_secret_key;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setConfigProperty', { property: 'paystack_secret_key', payload });
    },
  },
  tw_client_id: {
    get() {
      return this.$store.state.SettingsModule.Config.config.tw_client_id;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setConfigProperty', { property: 'tw_client_id', payload });
    },
  },
  tw_client_secret: {
    get() {
      return this.$store.state.SettingsModule.Config.config.tw_client_secret;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setConfigProperty', { property: 'tw_client_secret', payload });
    },
  },
  tw_redirect_uri: {
    get() {
      return this.$store.state.SettingsModule.Config.config.tw_redirect_uri;
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setConfigProperty', { property: 'tw_redirect_uri', payload });
    },
  },
  social_auth_ids: {
    get() {
      const ids = this.$store.state.SettingsModule.Config.config.social_auth_ids;

      return ids && ids.length > 0 ? ids : [];
    },
    set(payload) {
      this.$store.commit('SettingsModule/Config/setConfigProperty', { property: 'social_auth_ids', payload });
    },
  },
};

export default Config;
